<template>
  <div class="daftar_ruangan_tersedia">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>

            <v-card-title>
              <h3><b>Filter Ruangan Tersedia</b></h3>
            </v-card-title>
            
            <v-divider></v-divider>
            
            <v-card-text>
              <v-form class="px-3">
                <v-layout wrap>
                  <v-flex xs12 lg6>
                    <v-select
                      name="lokasi"
                      label="Lokasi"
                      :items="lokasi"
                      v-model="isiLokasi"
                      @change="onGedung">
                    </v-select>
                    <v-select
                      name="gedung"
                      label="Gedung"
                      :items="gedung"
                      v-model="isiGedung"
                      @change="onRuangan">
                    </v-select>
                    <v-autocomplete
                      name="kodeRuangan"
                      label="Ruangan"
                      :items="kodeRuangan"
                      v-model="isiKodeRuangan">
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 lg6>
                    <v-text-field
                      name="kapasitas"
                      label="Kapasitas"
                      type="number"
                      :items="kapasitas"
                      v-model="isiKapasitas"
                    >
                    </v-text-field>

                    <v-layout wrap>
                      <v-flex xs12 lg6>
                        <v-menu
                          ref="menu_start"
                          v-model="menu_start"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="date_start"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date_start"
                              label="Tanggal Mulai*"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date_start" no-title scrollable :min="minDate">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" style="min-width:100px;" @click="menu_start = false">Cancel</v-btn>
                            <v-btn text color="primary" style="min-width:100px;" @click="$refs.menu_start.save(date_start); menu_start = false">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_end"
                          v-model="menu_end"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="date_end"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date_end"
                              label="Tanggal Selesai*"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date_end" no-title scrollable :min="minDate">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" style="min-width:100px;" @click="menu_end = false">Cancel</v-btn>
                            <v-btn text color="primary" style="min-width:100px;" @click="$refs.menu_end.save(date_end); menu_end = false">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-flex xs12 lg6>
                        <v-menu
                          ref="menu_time_start"
                          v-model="menu_time_start"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="time"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="time_start"
                              label="Jam Mulai*"
                              prepend-icon="access_time"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="menu_time_start"
                            format="24hr"
                            v-model="time_start"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" style="min-width:100px;" @click="menu_time_start = false">Cancel</v-btn>
                            <v-btn text color="primary" style="min-width:100px;" @click="$refs.menu_time_start.save(time_start); menu_time_start = false">OK</v-btn>
                          </v-time-picker>
                        </v-menu>

                        <v-menu
                          ref="menu_time_end"
                          v-model="menu_time_end"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="time"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="time_end"
                              label="Jam Selesai*"
                              prepend-icon="access_time"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="menu_time_end"
                            format="24hr"
                            v-model="time_end"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" style="min-width:100px;" @click="menu_time_end = false">Cancel</v-btn>
                            <v-btn text color="primary" style="min-width:100px;" @click="$refs.menu_time_end.save(time_end); menu_time_end = false">OK</v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    
                    
                  </v-flex>
                </v-layout>

              </v-form>

              <v-btn 
                  class="filter-btn" 
                  color="deep-orange lighten-1"
                  small
                  dark
                  @click="onFilter"
                >
                  <v-icon left>
                    fa fa-filter
                  </v-icon> 
                  Cari
              </v-btn>

              <v-btn 
                  class="filter-btn" 
                  color="grey lighten-2"
                  small
                  @click="onReset"
                >
                  <v-icon left>
                    fa fa-repeat
                  </v-icon> 
                  Reset
              </v-btn>

            </v-card-text>

          </v-card>
        </v-flex>

        <v-flex lg12>
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                item-key="id"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.namaLokasi }}</td>
                  <td>{{ props.item.namaGedung }}</td>
                  <td>{{ props.item.kodeRuangan }}</td>
                  <td>{{ props.item.kapasitasMaksimal }}</td>
                  <td>{{ props.item.lantai }}</td>
                  <td>{{ props.item.jamKosongMulai }}</td>
                  <td>{{ props.item.jamKosongSelesai }}</td>
                  <td>
                    <v-layout>
                      <v-tooltip bottom>
                        <v-btn 
                            slot="activator"
                            depressed
                            fab
                            dark
                            small
                            color="orange darken-1"
                            @click="onBorrow(props.item)"
                        >
                          <v-icon>
                            fa fa-plus
                          </v-icon>
                        </v-btn>
                        <span>Tambah peminjaman ruang</span>
                      </v-tooltip>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {base} from "../../setup-axios"
import moment from "moment"
import { mapGetters,  mapActions} from 'vuex'
import {createJWT} from "../../store/module/helper";

  export default {
    name: "daftarRuanganTersedia",
    data() {
      return {
        time_start: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss').substring(11, 16),
        time_end: null,
        menu_time_start: false,
        menu_time_end: false,
        time: null,
        date: new Date().toISOString().substr(0, 10),
        date_start: new Date().toISOString().substr(0, 10),
        date_end: new Date().toISOString().substr(0, 10),
        menu_start: false,
        menu_end: false,
        headers: [
              {
                text: "Lokasi",
                value: ""
              },
              {
                text: "Gedung",
                value: "idGedung.nama"
              },
              {
                text: "Kode Ruangan",
                value: "kodeRuangan"
              },
              {
                text: "Kapasitas",
                value: "kapasitasMaksimal"
              },
              {
                text: "Lantai",
                value: ""
              },
              {
                text: "Jam Kosong Mulai",
                value: ""
              },
              {
                text: "Jam Kosong Selesai",
                value: ""
              },
              {
                text: "Aksi",
                value: ""
              }
            ],
        items: [],
        lokasi: [],
        gedung: [],
        kodeRuangan: [],
        kapasitas: [],
        lantai: [],
        isiLokasi: null,
        isiGedung: null,
        isiKodeRuangan: null,
        isiKapasitas: 0,
        isiLantai: null,
      }
    },

    created() {
      base.get("ruangan/ruangKosong",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
          var res = resp.data.result
          this.items = res
        }
      )

      base.get("lokasi/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.lokasi.push({value:resp.data.result[i].id, text:resp.data.result[i].nama})
          }
      })

      base.get("ruangan/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.kodeRuangan.push(resp.data.result[i].nama)
          }
      })

      var time_ended = new Date()
      
      var h_temp = time_ended.getHours()
      
      var h_next = time_ended.getHours() + 2

      var h

      if (h_temp == 22) {
        h = "00"
      } else if (h_temp == 23) {
        h = "01"
      } else {
        if ((h_next + "").length == 1) {
          h = "0" + h_next
        } else {
          h = h_next
        }
      }

      var m_temp = time_ended.getMinutes()

      var m

      if ((m_temp + "").length == 1) {
        m = "0" + m_temp
      } else {
        m = m_temp
      }

      this.time_end = h + ":" + m


    },

    computed:{
      minDate(){
        const today = new Date();
        // const dd = today.getUTCDate();
        return this.setMinDate(today);
      },
    },
    methods: {
      ...mapActions(["fetchRuangKosong"]),

      onBorrow(item) {
        this.fetchRuangKosong(item)
        this.$router.push("/peminjaman/add/");
      },

      setMinDate(date) {
        let month = `${date.getMonth() + 1}`;
        let day = `${date.getDate()}`;
        const year = date.getFullYear();

        if (month.length < 2) month = `0${month}`;
        if (day.length < 2) day = `0${day}`;

        return [year, month, day].join('-');
      },

      onFilter() {
        var kodeRuang = this.isiKodeRuangan == null ? null : this.isiKodeRuangan.split(" ")[0]
        var namaGedung = this.isiGedung == null ? 0 : this.isiGedung
        var namaLokasi = this.isiLokasi == null ? 0 : this.isiLokasi
        var url = "ruangan/filterRuangKosong/" + kodeRuang + "/" 
                  + namaGedung + "/" + namaLokasi + "/" + this.isiKapasitas 
                  + "/" + this.date_start + " " + this.time_start + ":00/"
                  + this.date_end + " " + this.time_end + ":00"

        this.items = []

        base.get(url,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          var res = resp.data.result
          this.items = res
        })
      },

      onReset(){
        var url = "ruangan/ruangKosong"

        this.items = []
        this.isiKodeRuangan = null
        this.isiLokasi = null
        this.isiGedung = 0
        this.isiKapasitas = 0
        this.date_start = ""
        this.date_end = null
        this.time_start = ""
        this.time_end = null

        this.onRuangan()

        base.get(url,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          var res = resp.data.result
          this.items = res
        })
      },

      onGedung(){
        base.get("gedung/lokasi/" + this.isiLokasi ,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.gedung = [{value:0,text:"--Pilih Gedung--"}]

          for(var i=0; i < resp.data.result.length;i++){
            this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })
      },
      onRuangan(){
        if(this.isiGedung == 0){
          base.get("ruangan/dropdown" ,
             {
               headers: {
                 Authorization: createJWT()
               }
             }
          ).then((resp) => {
            this.kodeRuangan = [{value:null,text:"--Pilih Ruangan--"}]
            for(var i=0; i < resp.data.result.length;i++){
              this.kodeRuangan.push(resp.data.result[i].nama)
            }
          })
        }

        else {
          base.get("ruangan/dropdown/byGedung/" + this.isiGedung ,
             {
               headers: {
                 Authorization: createJWT()
               }
             }
          ).then((resp) => {
            this.kodeRuangan = [{value:null,text:"--Pilih Ruangan--"}]
            for(var i=0; i < resp.data.result.length;i++){
              this.kodeRuangan.push(resp.data.result[i].nama)
            }
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>